export function unreachable(param: never) {
  return new Error(`Unreachable case with value ${JSON.stringify(param)}`);
}
